module.exports = __webpack_public_path__ + "img/unionpay.561413ac.png";